<template>
  <div class="operatingOptions">
    <!-- 配送单 -->
    <div class="shop">
      <p>
        <span>{{ $fanyi('商品种类') }}：</span>
        <span>{{ $parent.orderData.shangPinZhongLei }}</span>
      </p>
      <p>
        <span>{{ $fanyi('数量总计') }}：</span><span>{{ $parent.orderData.shuLiangZongJi }}</span>
      </p>
    </div>
    <!-- 付款 -->
    <div class="right">
      <div class="huiLvBox" v-if="['临时保存', '报价中'].indexOf($parent.pageStatus) == -1">
        <div class="youhuijuan" v-if="['等待付款'].indexOf($parent.pageStatus) != -1" @click="showCouponList">
          <div class="lefticon">
            <img src="@/assets/OrderDetails/coupon.svg" alt="" />
            <span class="coupon_num">{{
              $parent.datas.result.coupon_num
            }}</span>
          </div>
          <div class="coupontitle">
            <p v-if="$parent.istouseCoupon && $parent.CouponsData.title !== ''">
              - {{ $parent.CouponsData.title }}
            </p>
            <p v-else>{{ $fanyi('使用优惠券') }}</p>
          </div>
        </div>

        <p class="price">
          <span class="feiYongZongJi" v-if="['临时保存'].indexOf($parent.pageStatus) == -1">{{ $fanyi('费用总计') }}：</span>

          <span v-if="['临时保存'].indexOf($parent.pageStatus) == -1">
            ₴ {{ $parent.datas.result.amount }}</span>
        </p>
      </div>
      <div class="buttonGroup" v-if="['等待付款'].indexOf($parent.pageStatus) != -1">
        <button class="isPay" @click="$parent.goPay">
          {{ $fanyi('前往付款') }}
        </button>
      </div>
      <div class="buttonGroup" v-if="$parent.pageStatus == '乌克兰国内配送中'">
        <!-- 乌克兰国内配送中 -->
        <button class="sign" @click="$parent.sign">
          {{ $fanyi('签收') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      couponChecked: false,
    }
  },
  computed: {},
  created() { },
  methods: {
    //展示优惠券列表
    showCouponList(e) {
      this.$emit('showSelectCouponDialogVisible', true)
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../../../../../../css/mixin.scss';

.operatingOptions {
  width: 1400px;
  height: 100px;
  background: #ffffff;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 11, 38, 0.1);
  border-radius: 20px 20px 0px 0px;
  position: fixed;
  z-index: 3;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto 0;
  display: flex;
  padding: 0px 30px;
  justify-content: space-between;

  .shop {
    display: flex;

    flex-direction: column;
    justify-content: center;

    .shopNums {
      // display: flex;

      p {
        display: flex;
        align-items: center;
        min-height: 20px;
        margin-bottom: 2px;

        span {
          &:first-child {
            font-weight: 400;
            font-size: 14px;
            color: #121212;
          }

          &:last-child {
            font-weight: bold;
            font-size: 14px;
            color: #121212;
          }
        }
      }
    }
  }

  .right {
    display: flex;
    align-items: center;

    .huiLvBox {
      display: flex;
      align-items: center;

      .youhuijuan {
        display: flex;
        align-items: center;
        max-width: 160px;


        &:hover {
          cursor: pointer;
        }

        .lefticon {
          display: flex;
          flex-direction: column;
          font-weight: 500;
          font-size: 14px;
          color: #d12a1d;
          align-items: center;
          justify-content: center;

          margin-right: 10px;
          font-weight: 600;

          img {
            margin-bottom: 3px;
          }

          .coupon_num {
            line-height: 14px;
          }
        }

        .coupontitle {
          font-weight: 400;
          font-size: 14px;
          color: #d12a1d;
        }
      }

      .price {
        margin-left: 30px;
        display: flex;
        align-items: center;

        .feiYongZongJi {
          font-weight: 400;
          font-size: 14px;
          color: #121212;
          line-height: 20px;
        }

        span {
          font-weight: bold;
          font-size: 24px;
          color: #121212;
        }
      }
    }

    .buttonGroup {
      margin-left: 30px;

      .isPay {
        min-width: 160px;
        padding: 0 20px;
        height: 60px;
        background: #d12a1d;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 400;
        font-weight: 400;
        font-size: 18px;
        color: #ffffff;
        font-size: 18px;
        color: #ffffff;
        border-radius: 12px;
      }

      .sign {
        width: 160px;
        height: 60px;
        background: #2052ce;
        border-radius: 12px;
        display: flex;
        font-size: 18px;
        color: #ffffff;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>
